module.exports = "<!-- <div class=\"sidebar-header\"></div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module id = ../../../../../src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module chunks = main